import { createSlice } from "@reduxjs/toolkit";
import { TODAS_COBERTURAS } from "constants/tipoPoliza";

const initialState = {
  minPrice: null,
  maxPrice: null,
  filtroTipoCobertura: TODAS_COBERTURAS,
  filtroMinPrice: null,
  filtroMaxPrice: null,
  isLoading: false,
  isFiltering: false,
};

const polizaSelectorSlice = createSlice({
  name: "business/polizaSelector",
  initialState,
  reducers: {
    clearPolizaSelector: {
      prepare: () => ({ payload: {} }),
      reducer: () => initialState,
    },
    setFiltroTipoCobertura: {
      prepare: (value) => ({ payload: { value } }),
      reducer: (_state, action) => ({
        ...initialState,
        filtroTipoCobertura: action.payload.value,
        isFiltering: true,
      }),
    },
    setMinPrice: {
      prepare: (value) => ({ payload: { value } }),
      reducer: (state, action) => {
        state.minPrice = action.payload.value;
      },
    },
    setMaxPrice: {
      prepare: (value) => ({ payload: { value } }),
      reducer: (state, action) => {
        state.maxPrice = action.payload.value;
      },
    },
    setFiltroMinPrice: {
      prepare: (value) => ({ payload: { value } }),
      reducer: (state, action) => {
        state.filtroMinPrice = action.payload.value;
      },
    },
    setFiltroMaxPrice: {
      prepare: (value) => ({ payload: { value } }),
      reducer: (state, action) => {
        state.filtroMaxPrice = action.payload.value;
      },
    },
    setIsFiltering: {
      prepare: (value) => ({ payload: { value } }),
      reducer: (state, action) => {
        state.isFiltering = action.payload.value;
      },
    },
  },
});

const {
  clearPolizaSelector,
  setFiltroTipoCobertura,
  setMinPrice,
  setMaxPrice,
  setFiltroMinPrice,
  setFiltroMaxPrice,
  setIsFiltering,
} = polizaSelectorSlice.actions;

export default polizaSelectorSlice.reducer;
export {
  clearPolizaSelector,
  setFiltroTipoCobertura,
  setMinPrice,
  setMaxPrice,
  setFiltroMinPrice,
  setFiltroMaxPrice,
  setIsFiltering,
};
